var getIconSensor = function(val) {
    if (val == null) return '';
    switch(val){
        case "speed.png": {return '<i class="icon-49 coloricon" style="font-size: 20px;"></i>' }
        case "gsm.png": {return '<i class="icon-63 coloricon" style="font-size: 20px;"></i>' }
        case "ipwr.png": {return '<i class="icon-51 coloricon" style="font-size: 20px;"></i>' }
        case "epwr.png": {return '<i class="icon-52 coloricon" style="font-size: 20px;"></i>' }
        case "sat.png": {return '<i class="icon-47 coloricon" style="font-size: 20px"></i>' }
        case "fuel.png": {return '<i class="icon-58 coloricon" style="font-size: 20px"></i>' }
        case "fuel_benz.png": {return '<i class="icon-58 coloricon" style="font-size: 20px"></i>' }
        case "move.png": {return '<i class="icon-46 coloricon" style="font-size:10px;"></i>' }        
        case "parking.png": {return '<i class="icon-70 coloricon" style="font-size: medium;width: 12px;height: 12px;"></i>' }
        case "noparking.png": {return '<i class="icon-71 coloricon" style="font-size: 20px;"></i>' }
        case "zone.png": {return '<i class="icon-37 coloricon" style="font-size: 20px;"></i>' }
        case "key_engine.png": {return '<i class="fa key" style="font-size: medium;width: 12px;height: 12px;"></i>' }
        case "therm.png": {return '<i class="icon-57 coloricon" style="font-size: 20px"></i>' }
        case "last_connect.png": {return '<i class="icon-45 coloricon" style="font-size: 20px;"></i>' }
        case "addr.png": {return '<i class="icon-48 coloricon" style="font-size: 20px;"></i>' }
        case "engine.png": { return '<i class="icon-Starter coloricon" style="font-size: 12px;padding-left: 4px;"></i>' }
        case "parking_m.png": {return '<i class="icon-70 coloricon" style="font-size: 20px;"></i>' }
        case "red_button.gif": {return '<i class="icon-56 coloricon" style="font-size: 20px;"></i>' }
        case "sos.png": {return '<i class="icon-60 coloricon" style="font-size: 20px;"></i>' }
        case "wifi.png": {return '<i class="icon-55 coloricon" style="font-size: 20px;"></i>' }
    };
 
    if (val != "") return '<img src="../../../icons/' + val + '"/>';
    return "";
 }

 export default getIconSensor;


// WEBPACK FOOTER //
// ./app/getIconSensor.js